// Hides the designers feature behind the designers_enabled PostHog feature
// flag ($flags works during SSR via posthog-node and on the client via the
// cookie-bootstrapped posthog-js; non-production stages read the local value
// from ~/experiments/posthog). A 404 (not a redirect) keeps the toggle
// instant: permanent redirects would be cached by browsers past a flag flip.
export default function ({ $flags, error }) {
  if (!$flags.isFeatureEnabled("designers_enabled")) {
    error({ statusCode: 404, message: "Page not found" });
  }
}
